const getHashUrlContent = customUrl => customUrl.slice(customUrl.indexOf('#')) || '';

const getDepartmentIdFromCustomUrl = (customUrl = '') => {
  const hash = getHashUrlContent(customUrl);
  return hash?.split('department=')[1]?.split('&')[0] || '';
}

export default getDepartmentIdFromCustomUrl;
